import { Component, OnInit , Inject, Input } from '@angular/core';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { TypedefdialogComponent } from '../typedefdialog/typedefdialog.component';

import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';

export interface DialogData {
	ParamsName : string[]; 
	typechoice: string[];
}


@Component({
  selector: 'app-vehiculeparam',
  templateUrl: './vehiculeparam.component.html',
  styleUrls: ['./vehiculeparam.component.css']
})
export class VehiculeparamComponent implements OnInit {



  possibleParams = [] ;
  choosenParams = [] ;


  rowNumber = 0 ;
  resultArray = [] ;
  subTabLength = 4 ;

  checkStatus = [] ;

  checkboxEditDeactivate = [] ;

  saveBtnState = "done_all" ;

  eltsType = [] ;

  baseElement = "" ;

  constructor(public dialogRef: MatDialogRef<VehiculeparamComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData, public dialog: MatDialog) {
  	this.possibleParams = data.ParamsName ;
  	console.log(this.possibleParams) ;
  }

  ngOnInit(): void {
  	var onChunkArray = [] ;
  	var index = 0 ;
  	this.resultArray = this.possibleParams.reduce((indexDead, item ) => { 
  		const chunkIndex = Math.floor(index/this.subTabLength)
  		if(!onChunkArray[chunkIndex]) {
  			onChunkArray[chunkIndex] = [] ;
  		}
  		onChunkArray[chunkIndex].push(item) ;
  		index++ ;
  		return onChunkArray ;
  	}, []) ;

  	for (var i = 0; i< this.possibleParams.length; i++) {
  		this.checkStatus.push(false) ;
  		this.checkboxEditDeactivate.push(false) ;
      this.eltsType.push([]) ;
  	}
  }

  openDialog(nomParam, typeIndex) {
    const dialogRef = this.dialog.open(TypedefdialogComponent, {
      data: {
        ParamsName: nomParam,
        typechoice: ["***"]
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The Type COnfiguration is ::: ');
      this.eltsType[typeIndex] = result ;
    });
  }

  saveVehicParams(){
    var typologie = [] ;
    for (var i = 0; i<this.possibleParams.length ; i++) {
      if(this.checkStatus[i]==true){
        this.choosenParams.push(this.possibleParams[i]) ;
        //typologie.push(this.eltsType[i]) ;        
      }
    }

    var ret = JSON.stringify({"choosenParams": this.choosenParams, "typos": typologie }) ;
    console.log(ret) ;
    this.dialogRef.close(ret);
  }


  onPrimeChoose(event, i, j) {
  	if (event.target.checked){
  		this.checkStatus[j+4*i]=true ;
  		//this.openDialog(this.possibleParams[j+4*i], j+4*i) ;
  	}
  	else{
  	  	console.log("UNCHECKED "+event.target.value) ;
    		this.checkStatus[j+4*i]=false ;	  	
  	}
  	console.log(this.baseElement);	
  }


}
